import React from 'react';
import styled from 'styled-components';
import { NavList, menu } from './';
import { device } from 'vqp-common';

const Wrapper = styled.div`
  width: ${(props) => props.theme.dimensions.navBarWidth}px;
  position: fixed;
  top: ${(props) => props.theme.dimensions.headerHeightDesktop}px;
  bottom: 0;

  @media ${device.mobile} {
    left: -${(props) => props.theme.dimensions.navBarWidth}px;
    transition: all 0.3s;
    ${(props) =>
      props.open &&
      `
            left: 0;
        `}
  }
`;

export const NavBar = ({ open, accessControl }) => {
  const availableMenuItems = menu.filter((menuItem) => accessControl[menuItem.accessControlName]);

  return (
    <Wrapper open={open}>
      <NavList items={availableMenuItems} />
    </Wrapper>
  );
};
